import { __rest } from "tslib";
import clsx from 'clsx';
import { bool, number, oneOfType, string } from 'prop-types';
import React from 'react';
import CharacterCount from './CharacterCount';
import './TextArea.less';
const DEFAULT_TEXT_ROWS = 4;
const NEARLY_TOO_LONG_FACTOR = 0.8;
export default function TextArea(props) {
    const { className, value = '', error = false, rows = DEFAULT_TEXT_ROWS, maxLength, disabled, hideCharacterCount } = props, otherProps = __rest(props, ["className", "value", "error", "rows", "maxLength", "disabled", "hideCharacterCount"]);
    const actualLength = value ? value.length : 0;
    const isTooLong = actualLength > maxLength;
    const isNearlyTooLong = !isTooLong && actualLength > maxLength * NEARLY_TOO_LONG_FACTOR;
    const anyError = error || isTooLong;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: clsx(className, 'kal-text-area', anyError && 'kal-form-error', isNearlyTooLong && 'kal-form-advisory') },
            React.createElement("textarea", Object.assign({ value: value || '', rows: rows, disabled: disabled }, otherProps))),
        React.createElement(CharacterCount, { maxLength: maxLength, actualLength: actualLength, isTooLong: isTooLong, isNearlyTooLong: isNearlyTooLong, disabled: disabled, hideCharacterCount: hideCharacterCount })));
}
TextArea.propTypes = {
    className: string,
    value: string,
    disabled: bool,
    error: oneOfType([bool, string]),
    rows: number,
    maxLength: number,
    hideCharacterCount: bool,
};
//# sourceMappingURL=TextArea.js.map